import React from "react";
import { Route, Routes } from "react-router";
import Layout from "../../views/layout";
import Error404 from "../auth/error/error-404/error400";
import { publicRoutes } from "./router.link";
import Login from "../../views/Login";
import QrLogin from "../../views/QrLogin";


const ALLRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path='/login' element={<Login />} />
            <Route path='/qr-login' element={<QrLogin />} />
            <Route element={<Layout />}>
                {publicRoutes.map((route, idx) => (
                    <Route path={route.path} element={route.element} key={idx} />
                ))}
            </Route>
            {/* Create a fallback to 404 */}
            <Route path="*" element={<Error404 />} />
        </Routes>
    );
};

export default ALLRoutes;

